import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {ChartService} from '../../chart.service';

import * as fromApp from '../../../store/app.reducers';
import * as ProfileActions from '../../store/profile.actions';
import * as PostActions from '../../post/store/post.actions';
import * as DemoActions from '../../../demo/store/demo.actions';
import * as fromProfile from '../../store/profile.reducers';
import {Chart} from 'angular-highcharts';
import {Profile} from '../../profile.model';
import {HelperService} from '../../../share/helper.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-followers-reliability',
    templateUrl: './followers-reliability.component.html',
    styleUrls: ['./followers-reliability.component.scss'],
    standalone: false
})
export class FollowersReliabilityComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  @Input() id: number;
  code: string;
  typeFollowers: number;
  typeProgress: string;
  initData: boolean;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsFollower: Chart[];
  audit: Profile;
  readonly auditType = input<'profile' | 'demo'>(undefined);
  sectionName = {
    'qualityFollowers': '',
    'qualityDistribution': ''
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService,
    private helperService: HelperService
  ) { }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnInit() {
    this.typeFollowers = 1;
    this.sectionName.qualityDistribution = this.helperService.generateRandomString(10);
    this.sectionName.qualityFollowers = this.helperService.generateRandomString(10);

    this.initData = false;
    if (+this.type() === 1) {
      this.typeProgress = 'follower';
    } else if (+this.type() === 2) {
      this.typeProgress = 'like';
    }
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
      }
    );
    this.profileSubscription = this.store.select(this.getAuditType()).subscribe(
      (state: fromProfile.State) => {
        this.audit = state.audit;
        const auditType = this.auditType();
        if (state.audit !== null && state.audit.status !== 0 && !this.initData && auditType === 'profile') {
          this.initData = true;
          if (this.id !== undefined) {
            this.setTypeFollowers(this.typeFollowers);
          }
        }
        if (state.followerStat !== null && (state.chartReload === this.getAuditActions().SET_FOLLOWER_STAT || auditType === 'demo')) {
          this.chartsFollower = [];
          this.chartsFollower.push(
            ChartService.getQualityDistributionChart(state.followerStat),
            ChartService.getAudienceTypeChart(state.followerStat)
          );
          if (state.followerStat.private !== undefined) {
            this.chartsFollower.push(
              ChartService.getIsChart(state.followerStat.private, 'private')
            );
          }
          if (state.followerStat.business !== undefined) {
            this.chartsFollower.push(
              ChartService.getIsChart(state.followerStat.business, 'business')
            );
          }
        }

      }
    );

  }

  getLevel(percent: number) {
    return ChartService.conditionLevel(percent);
  }

  Math() {
    return Math;
  }

  setTypeFollowers(type: number) {

    if (this.id !== undefined && this.audit !== null && this.audit.status !== 0) {
      this.typeFollowers = type;

      if (+this.type() === 1) {
        if (+type === 1 || +type === 2) {
          this.store.dispatch(
            new ProfileActions.GetFollowerStat({
              id: +this.id,
              type: type,
              params: {
                code: this.code
              }
            })
          );
        } else if (+type === 3) {
          this.store.dispatch(
            new ProfileActions.GetFollowerStat({
              id: +this.id,
              type: 1,
              params: {
                code: this.code
              }
            })
          );
        }

      } else if (+this.type() === 2) {
        this.store.dispatch(
          new PostActions.GetFollowerStat({
            id: +this.id,
            type: 2
          })
        );
      }
    } else if (this.audit !== null && this.audit.status === 0) {
      this.notifierService.warning('No access in trial account');
    } else {
      this.notifierService.warning('No access in demo audit');
    }

  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
